import { ArtistMinifiedType } from '@api';
import { TouringDataTable, useManageTableContext } from '@common*';
import { useArtistsOverviewTableColumns, useDeleteArtist } from './hooks';

type ArtistsOverviewTablePropsType = {
  artists: ArtistMinifiedType[];
  isPending: boolean;
};

export const ArtistsOverviewTable: React.FC<ArtistsOverviewTablePropsType> = ({
  artists,
  isPending,
}) => {
  const { handleDeleteArtist } = useDeleteArtist();

  const { columns } = useArtistsOverviewTableColumns({ handleDeleteArtist });

  const { tableArguments: table } = useManageTableContext();

  return (
    <TouringDataTable<ArtistMinifiedType>
      columns={columns}
      records={artists}
      {...table.pagination}
      {...table.sorting}
      fetching={isPending}
    />
  );
};
